"use strict";

/**
 * 根据身份证获得年龄
 * @param str
 * @returns {string}
 */
var timeF = require('lmw-time-format');
module.exports = function (str) {
  if (!str) return "";
  var now = new Date().getTime(),
      old = void 0;
  now = timeF(now, "%Y");
  if (str.length == 18) {
    old = str.substr(6, 4);
    return parseInt(now) - parseInt(old);
  }
  if (str.length == 15) {
    old = str.substr(6, 2);
    return parseInt(now) - parseInt(old);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ty-vue-filters@1.0.22@ty-vue-filters/dist/filters/getAgeFromIdCard.js
// module id = hhSG
// module chunks = 300